import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import AppRow from "@/components/AppRow";

export default function CategoryView() {
  const { name } = useParams();
  const [apps, setApps] = useState(null);
  const cat = decodeURIComponent(name || "");

  useEffect(() => {
    api.apps({ category: cat }).then(setApps).catch(() => setApps([]));
  }, [cat]);

  return (
    <div className="pb-28">
      <Header title={cat} subtitle="Категория" back />
      <div className="px-4 pt-2">
        {apps === null ? (
          <div className="py-10 text-center text-slate-500">Загрузка…</div>
        ) : apps.length === 0 ? (
          <div className="py-10 text-center text-slate-500">В этой категории пока пусто.</div>
        ) : (
          <div className="divide-y divide-white/5">
            {apps.map((app, i) => (
              <AppRow key={app.id} app={app} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
